import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col full-width full-height references-compact-container min-height" }
const _hoisted_2 = { class: "references-header-container" }
const _hoisted_3 = { class: "references-index-container" }

import {ref} from 'vue';
  import ReferencesIndex from 'components/references/ReferencesIndex.vue';
  import ReferencesDetail from 'components/references/ReferencesDetail.vue';
  import ReferencesHeader from 'components/references/ReferencesHeader.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesPane',
  setup(__props) {

  const splitterModel = ref(40);


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createBlock(_component_q_splitter, {
    modelValue: splitterModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitterModel).value = $event)),
    class: "references-pane",
    limits: [30, 100],
    "separator-style": "width: 6px; background-color: #F0F6FA;",
    "before-class": "iodine-border",
    "after-class": "iodine-border"
  }, {
    before: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ReferencesHeader)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ReferencesIndex)
        ])
      ])
    ]),
    after: _withCtx(() => [
      _createVNode(ReferencesDetail)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})